import PropTypes from 'prop-types';
import { Component } from 'react';
import ExportModal from './ExportModal';

const propTypes = {
    //  Pass a component that will get instantiated as initial panel in the modal.
    //  The component receives the following props:
    //    - void onExport(downloadableFile)
    //          A function that you call after you triggered the download. The
    //          modal will automatically go into progress mode and poll for the file.
    //    - void onCancel()
    //          A void function to close the modal
    bodyComponent: PropTypes.func.isRequired,

    // This is the element that will open the modal on click
    children: PropTypes.node.isRequired,

    //  An callback that is invoked after the modal gets closed.
    //  This might be used to clean up resources or to adjust the view (e.g. in an <Option />)
    onClose: PropTypes.func,
};

export default function withExportModal(WrappedComponent) {
    return class ComponentWithModal extends Component {
        state = {
            isModalOpen: false,
        };
        static propTypes = propTypes;

        handleOpen = () => {
            this.setState({ isModalOpen: true });
        };

        handleClose = () => {
            this.setState({ isModalOpen: false });
            if (this.props.onClose) {
                this.props.onClose();
            }
        };

        render() {
            const { onClose, bodyComponent, ...props } = this.props; // eslint-disable-line @typescript-eslint/no-unused-vars
            return (
                <>
                    <WrappedComponent {...props} onClick={this.handleOpen} />
                    <ExportModal
                        isOpen={this.state.isModalOpen}
                        onClose={this.handleClose}
                        bodyComponent={bodyComponent}
                    />
                </>
            );
        }
    };
}
